import { KeyValueLabel, NoValue } from '@tribeauto/ngx-mobilite-material';
import { posAll } from '../../core/helpers/point-of-sale.helper';
import { LeadsFilterData } from '../pages/records/records.component.model';
import { WritableSignal } from '@angular/core';

export const getDefaultPos = (pos: string | NoValue): KeyValueLabel => {
  if (pos) {
    return { key: pos, value: pos };
  }
  return posAll;
};

export const initFiltersFormSignal = <T extends LeadsFilterData>(
  filters: WritableSignal<T>,
  pos: string | NoValue,
  cckNumber: string | NoValue,
  name: string | NoValue,
  tveiListMap: KeyValueLabel[]
): void => {
  const queryTvei = pos ? tveiListMap.find(tvei => tvei.value === pos) : undefined;
  filters.update(currentFilters => ({
    ...currentFilters,
    pos: queryTvei ?? tveiListMap[0] ?? null,
    ...(cckNumber ? { cckNumber } : {}),
    ...(name ? { name } : {})
  }));
};
